const isProduction = process.env.NODE_ENV === 'production';
const API_BASE_URL = isProduction
  ? '/api/wheel'
  : (process.env.REACT_APP_API_URL || 'http://localhost:3000/api/wheel');

// Ensure trailing slash is consistent
export default API_BASE_URL.replace(/\/$/, '');
